export default "/static/webpack/media/big-five-diagram.xx.ed18d452.svg";